import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiHelper} from './api.helper';
import {WPCustomFieldsTaxonomyItem} from '../types/WPCustomFieldsTaxonomyItem';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AppConfigService} from "./app-config.service";

@Injectable()
export class AdcampaignService {
  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private appConfigService: AppConfigService
  ) {
  }

  public getAdCampaignOwners(
    campaignCareServiceType: WPCustomFieldsTaxonomyItem[],
    campaignSymptom: WPCustomFieldsTaxonomyItem[]
  ): Observable<number[]> {
    const endpoint: string = this.prepareApiUrlWithQueryParams(
      campaignCareServiceType,
      campaignSymptom
    );
    return this.http
      .get<number[]>(endpoint)
      .pipe(catchError((error) => of(null)));
  }

  public getAdCampaignOwner(id: number): Observable<number> {
    const apiUrl: string = this.appConfigService.appConfig.apiUrl;
    let endpoint: string = `${apiUrl}AdCampaign/owner?adCampaignId=${id}`;
    return this.http
      .get<number>(endpoint)
      .pipe(catchError((error) => of(null)));
  }

  private prepareApiUrlWithQueryParams(
    campaignCareServiceType: WPCustomFieldsTaxonomyItem[],
    campaignSymptom: WPCustomFieldsTaxonomyItem[]
  ): string {
    const apiUrl: string = this.appConfigService.appConfig.apiUrl;
    const urlParts: string[] = [];
    let endpoint: string = `${apiUrl}AdCampaign/owners?`;

    if (campaignCareServiceType && campaignCareServiceType.length > 0) {
      const itemQueryParts: string[] = campaignCareServiceType.map(
        (item) => item.slug
      );
      urlParts.push(
        `careServiceTypeUrlPaths=${encodeURIComponent(
          itemQueryParts.join(',')
        )}`
      );
    }

    if (campaignSymptom && campaignSymptom.length > 0) {
      const itemQueryParts: string[] = campaignSymptom.map((item) => item.slug);
      urlParts.push(
        `symptomUrlPaths=${encodeURIComponent(itemQueryParts.join(','))}`
      );
    }

    return `${endpoint}${urlParts.join('&')}`;
  }
}
